import { IApplicationState } from '../../types/redux';

export function getNewbuildingBrokerBookingAvailable(state: IApplicationState) {
  return state.newbuilding.isNewbuildingBrokerBookingAvailable;
}
